export enum $trainingVideo {
  _id = '_id',
  url = 'url',
  workspace = 'workspace',
  createdAt = 'createdAt',
  tenantId = 'tenantId',
}

export const trainingVideoAllowedHostnames: string[] = ['player.vimeo.com'];
